/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = (componentRegistry) => {
  componentRegistry.useModulePlugin("FilterAPI", {
    name: "custom collection page",
    apply(builder) {
      builder.on("methodFulfilled", "get", (data) => {
        if (data.args[1].page === 1) {
          setTimeout(function () {
            const productItems = document.querySelectorAll(".boost-sd__product-item");
            
            // Define the two images
            const img1 = `<a href="https://legacytouch.com/pages/email-signup"><img src="https://cdn.shopify.com/s/files/1/0149/7343/5968/files/EmailSignUp-desktop.jpg?v=1721092798"></a>`;
            const img2 = `
              <a class="idme-trigger-link idme-unify-button" 
                 href="https://discountify.id.me/oauth/checkpoint/legacytouch" 
                 target="_parent" 
                 data-uw-rm-brl="PR" 
                 data-uw-original-href="https://discountify.id.me/oauth/checkpoint/legacytouch">
                <img src="https://cdn.shopify.com/s/files/1/0149/7343/5968/files/Id.me-discount_2d725c32-f800-473b-9422-2a66e9021dd1.jpg?v=1742477224" 
                     alt="ID.me Logo" 
                     data-uw-rm-alt-original="ID.me Logo" 
                     role="img" 
                     data-uw-rm-alt="ALT">
              </a>
            `; // Updated to include the anchor tag with the second image

            // Add the first image to the 2nd slot
            addBanner(productItems, img1, 2);

            // Add the second image (with anchor) to the 5th slot
            addBanner(productItems, img2, 4);
          }, 5);
        }
      });
    },
  });

  componentRegistry.useModulePlugin("SearchAPI", {
    name: "custom search page",
    apply(builder) {
      builder.on("methodFulfilled", "searchInCollection", (data) => {
        if (data.result && data.result.hasOwnProperty("filter")) {
          // customFunction(data);
        }
      });
    },
  });
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize]);

function addBanner(productItems, img, position) {
  if (Array.from(productItems).length > position) {
    const productItemAt = Array.from(productItems).at(position - 1);

    const bannerHtml = `
      <div class="boost-sd__product-item boost-sd__product-item--banner boost-sd__product-item--noBorder boost-sd__product-item-grid-view-layout">
        ${img} <!-- Insert the image or anchor tag directly here -->
      </div>
    `;
    if (!document.querySelector(`.boost-sd__product-item--banner[data-position="${position}"]`)) {
      productItemAt.insertAdjacentHTML("beforebegin", bannerHtml);
      productItemAt.previousElementSibling.setAttribute("data-position", position); // Set a unique identifier for each banner
    }
  }
}

